import React, { createContext, useState, useEffect } from "react";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const ModulesContext = createContext({});

const ModulesProvider = ({ children }) => {
  const [modules, setModules] = useState({
    moduleCalendar: "enabled",
    moduleInternalChat: "enabled",
    moduleSms: "enabled",
    moduleApi: "enabled",
    moduleAutoSchedule: "enabled"
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const { data } = await api.get("/settings");
        
        const moduleSettings = {
          moduleCalendar: data.find(s => s.key === "moduleCalendar")?.value || "enabled",
          moduleInternalChat: data.find(s => s.key === "moduleInternalChat")?.value || "enabled",
          moduleSms: data.find(s => s.key === "moduleSms")?.value || "enabled",
          moduleApi: data.find(s => s.key === "moduleApi")?.value || "enabled",
          moduleAutoSchedule: data.find(s => s.key === "moduleAutoSchedule")?.value || "enabled"
        };
        
        setModules(moduleSettings);
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchModules();
  }, []);

  const isModuleEnabled = (moduleName) => {
    return modules[moduleName] === "enabled";
  };

  return (
    <ModulesContext.Provider value={{ modules, loading, isModuleEnabled }}>
      {children}
    </ModulesContext.Provider>
  );
};

export { ModulesContext, ModulesProvider };
